import { render } from "./CustomMessageDialogue.vue?vue&type=template&id=df5606f2&scoped=true"
import script from "./CustomMessageDialogue.vue?vue&type=script&lang=js"
export * from "./CustomMessageDialogue.vue?vue&type=script&lang=js"

import "./CustomMessageDialogue.vue?vue&type=style&index=0&id=df5606f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5606f2"]])

export default __exports__